<template>
    <div class="tab-pane" id="gov-sholarship" :class="{'active' : user_type=='1'}" aria-labelledby="gov-sholarship">
        <div class="alert alert-warning alert-dismissible fade show" role="alert">
            APPLICATION ACCEPTANCE WILL FROM <strong>{{start_date}} </strong> TILL <strong> {{end_date}} </strong>.
        </div>
        <div class="card">
            <label class="card-header text-center"><strong>Sholarship Details</strong></label>
            <table class="table table-bordered table-striped" id="OrgDetails">
                <thead>
                    <tr>
                        <th class="text-center"> </th>
                        <th colspan="6" class="text-center">Student Information</th>
                        <th colspan="2" class="text-center">Class</th>
                        <th colspan="3" class="text-center">Admission</th>
                    </tr>
                    <tr>
                        <th>S.No</th>
                        <th>Name of Student</th>
                        <th>Index Number</th>
                        <th>Student Code</th>
                        <th>Percentage</th>
                        <th>Dzongkhag</th>
                        <th>School</th>
                        <th>Class</th>
                        <th>Stream</th>
                        <th>Status</th>
                        <th v-if="show_remarks_column==1">Remarks</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="(item,index) in admission" :key="index">
                        <td>{{index + 1}}</td>
                        <td>{{item.name}}</td>
                        <td>{{item.std_indexno}}</td>
                        <td>{{item.student_code}}</td>
                        <td>{{item.percentage}}</td>
                        <td>{{item.dzongkhag}}</td>
                        <td>{{item.organization}}</td>
                        <td>{{item.class}}</td>
                        <td>{{item.stream}}</td>
                        <td>
                            <select v-model="admission[index].status" class="form-control form-control-sm" aria-label="status" :disabled="show_remarks_column==1">
                                <option value="0">Pending</option>
                                <option value="1">Not Accepted</option>
                                <option value="2">Accepted</option>
                            </select>
                        </td>
                        <td v-if="show_remarks_column==1">
                        <span v-if="item.remarks == 'admitted'">
                            Admitted
                        </span>
                         <span v-else>
                            Not Admitted
                        </span>
                        </td>
                    </tr>
                </tbody>
            </table>
            <div v-if="show_remarks_column==0" class="text-right mb-2 mr-2">
                <button type="button" class="btn btn-primary" @click="updateAdmissionStatusBySchool"><i class="fa fa-save"></i>  Save</button> 
            </div>
        </div>
    </div>
</template>
<script>
export default {
    props:['start_date','end_date'],
    data(){
        return {
            user_type:'',
            admission:[],
            show_remarks_column:0
        }
    },
    methods:{
        getApplication(school_id){
            axios.get('admissions/getApplication/'+school_id).then(res =>{
                let data = res.data;
                data.forEach(item => {
                    if(item.remarks == 'admitted'){
                        this.show_remarks_column = 1;
                    }
                })
                this.admission = data
            }).catch(error => console.log(error));
        },
        updateAdmissionStatusBySchool(){
            axios.post('admissions/updateAdmissionStatus',{admission:this.admission}).then(res => {
               Toast.fire({
                    icon: 'success',
                    title: 'Deatail updated successfully'
                })
                this.$router.go(this.$router.currentRoute)
            }).catch(error => console.log(error))
        },
        remove_err(fieldid){
            if($('#'+fieldid).val()!=""){
                $('#'+fieldid).removeClass('is-invalid');
            }
        }
    },
    mounted(){
        axios.get('getSessionDetail')
        .then(response => {
            let data = response.data.data;
            this.user_type=data['role'];
            this.getApplication(data['organization_id']);
        })
    }
    
}
</script>